import { Injectable } from '@angular/core';

export const TOKEN_NAME: string = 'token';

@Injectable()
export class AuthService {
  constructor() { }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_NAME, token);
  }

  isAuthenticated(token?: string): boolean {
    return !!localStorage.getItem(TOKEN_NAME);
  }
}


// WEBPACK FOOTER //
// ./src/providers/Auth/auth.service.ts